import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataContentType } from 'components/common/element-data/types';
import useBundleTranslation from 'i18n';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';
import { Box } from '@mui/material';

export default function ContentType(props: IElementDataContentType) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { elementId = 0, contentType = '', settings } = props;
    const fieldKey: ElementMetadataFieldName = 'content_type';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    if (!fieldMetadataDisplay || !contentType) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <Box>
                <Box component={'span'} sx={{ fontWeight: 600 }}>
                    {contentType}
                </Box>
                {elementId && (
                    <>
                        <Box component={'span'}> | </Box>
                        <Box component={'span'}>
                            {t('element_data_common.id')}: {elementId}
                        </Box>
                    </>
                )}
            </Box>
        </ElementDataRow>
    );
}
